/**
 * Reusable loading + empty state for screens that fetch data on mount.
 *
 * <LoadingState loading={loading} empty={!items.length} emptyIcon="⛳"
 *               emptyTitle="No games yet" emptyHint="Start a round to see history">
 *   {items.map(...)}
 * </LoadingState>
 */
export default function LoadingState({
  loading,
  empty,
  emptyIcon = '⛳',
  emptyTitle = 'Nothing here yet',
  emptyHint,
  children,
}) {
  if (loading) {
    return (
      <div className="loading-state">
        <div className="spinner" />
        <span className="loading-state-label">Loading…</span>
      </div>
    );
  }
  if (empty) {
    return (
      <div className="empty-state">
        <div className="icon">{emptyIcon}</div>
        <h3>{emptyTitle}</h3>
        {emptyHint && <p>{emptyHint}</p>}
      </div>
    );
  }
  return children;
}
